import Constants from '@intercom/embercom-composer/lib/constants';
import HtmlEscaper from '@intercom/embercom-composer/lib/html-escaper';
import createJQueryObjectFromString from '@intercom/embercom-composer/lib/create-jquery-object-from-string';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import $ from 'jquery';
const nodeToHtml = function (node, allowedChildNodeNames) {
  let src;
  let html = '';
  if (node.nodeType === undefined) {
    //it's a node list
    allowedChildNodeNames = allowedChildNodeNames || [];
    let nodes = node;
    for (let i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (allowedChildNodeNames.length > 0 && !allowedChildNodeNames.includes(node.nodeName)) {
        if (node.nodeType === Node.TEXT_NODE) {
          html += HtmlEscaper.escape(node.textContent);
        } else {
          html += nodeToHtml(node.childNodes, allowedChildNodeNames);
        }
      } else {
        html += nodeToHtml(node, allowedChildNodeNames);
      }
    }
    return html;
  } else if (node.nodeType === Node.TEXT_NODE) {
    return HtmlEscaper.escape(node.textContent);
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    switch (node.nodeName) {
      case 'A':
        {
          if (node.classList.contains('intercom-interblocks-link')) {
            return node.outerHTML;
          }
          let cleanContents = nodeToHtml(node.childNodes, ['B', 'STRONG', 'EM', 'I', 'SPAN', 'IMG', 'IC-ATTRIBUTE']);
          let href = node.getAttribute(Constants.COPY_SAFE_HREF_ATTRIBUTE) || node.getAttribute('href');
          if (!href) {
            return cleanContents;
          }
          return `<a href="${href}">${cleanContents}</a>`;
        }
      case 'B':
      case 'STRONG':
        return `<b>${nodeToHtml(node.childNodes, ['I', 'EM', 'A', 'IC-ATTRIBUTE'])}</b>`;
      case 'IC-ATTRIBUTE':
        {
          //TODO: GJ: htmlUnescape
          let identifier = node.getAttribute('data-identifier');
          let fallback = node.getAttribute('data-fallback');
          if (fallback) {
            return `{{${identifier}|${fallback}}}`;
          }
          return `{{${identifier}}}`;
        }
      case 'IC-BLOCK':
        return node.outerHTML;
      case 'I':
      case 'EM':
        return `<i>${node.textContent}</i>`;
      case 'H1':
        return `<h1 data-align=\"${getAlignment(node)}\">${nodeToHtml(node.childNodes, ['A', 'IC-ATTRIBUTE'])}</h1>`;
      case 'H2':
      case 'H3':
      case 'H4':
      case 'H5':
      case 'H6':
        return `<h2 data-align=\"${getAlignment(node)}\">${nodeToHtml(node.childNodes, ['A', 'IC-ATTRIBUTE'])}</h2>`;
      case 'UL':
        if (!node.childNodes.length) {
          return '';
        }
        return `<ul>${nodeToHtml(node.childNodes, ['LI'])}</ul>`;
      case 'OL':
        if (!node.childNodes.length) {
          return '';
        }
        return `<ol>${nodeToHtml(node.childNodes, ['LI'])}</ol>`;
      case 'LI':
        return `<li>${nodeToHtml(node.childNodes, ['B', 'I', 'A', 'IC-ATTRIBUTE'])}</li>`;
      case 'P':
        return `<p data-align=\"${getAlignment(node)}\">${nodeToHtml(node.childNodes)}</p>`;
      case 'BR':
        return '<br>';
      case 'CODE':
        return `<code>${nodeToHtml(node.childNodes, ['PRE', 'BR'])}</code>`;
      case 'PRE':
        {
          let result = `<pre class="code">${nodeToHtml(node.childNodes, ['BR', 'CODE', 'PRE'])}</pre>`;
          return result.replace(/<br>/g, '\n');
        }
      case 'SPAN':
      case 'TABLE':
      case 'TBODY':
      case 'TR':
        return nodeToHtml(node.childNodes);
      case 'DIV':
        return `<p>${nodeToHtml(node.childNodes, ['DIV', 'P', 'H1', 'H2', 'OL', 'UL', 'IMG', 'B', 'I', 'A', 'BR'])}</p>`;
      case 'TD':
        return `${node.textContent} `;
      case 'IMG':
        src = node.getAttribute('src');
        if (!src) {
          return '';
        }
        return `<img src="${src}" />`;
      case 'IFRAME':
        src = node.getAttribute('src');
        if (!src || !src.match(Constants.YOUTUBE_IFRAME_EMBED_URL_REGEX)) {
          return '';
        }
        return `<iframe src="${src}"></iframe>`;
      default:
        return nodeToHtml(node.childNodes, ['DIV', 'P', 'H1', 'H2', 'OL', 'UL', 'IMG', 'B', 'I', 'A', 'BR']);
    }
  } else {
    return '';
  }
};
let getAlignment = function (node) {
  let alignment = node.getAttribute('data-align');
  return ['left', 'center', 'right'].includes(alignment) ? alignment : 'left';
};
let replaceNewLines = function ($content) {
  $content.find('pre').each(function () {
    // eslint-disable-next-line jquery-unsafe/no-html
    $(this).html($(this).html().replace(/\n/g, '<br>'));
  });
  /* @pat Disabling the sanitization lint rule because we call our intercom
   * sanitization library at the very end of this module */
  /* eslint-disable-next-line jquery-unsafe/no-html */
  $content.html($content.html().replace(/\n/g, ''));
};
let removePasteArtefacts = function ($content) {
  $content.find('br.Apple-interchange-newline').remove();
};
export default function (html) {
  html = html.replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '');
  let $content = createJQueryObjectFromString(html);
  replaceNewLines($content);
  removePasteArtefacts($content);
  let result = nodeToHtml($content.contents());
  let sanitizedResult = sanitizeHtml(result);
  return sanitizedResult.string;
}